module.exports = __webpack_public_path__ + "images/giftTree/favors.5a588b00467e8ea06bba25c9d3cbbdc9.png";